import type { Category, Finding, FindingStatus, Severity } from '../types/api';

export interface FindingFilterState {
  severities: Severity[];
  category: Category | 'all';
  file: string | 'all';
  status: FindingStatus | 'all' | 'active';
}

export const defaultFilters = (severities: Severity[]): FindingFilterState => ({
  severities,
  category: 'all',
  file: 'all',
  status: 'all',
});

export function applyFindingFilters(findings: Finding[], f: FindingFilterState): Finding[] {
  return findings.filter(
    (x) =>
      f.severities.includes(x.severity) &&
      (f.category === 'all' || x.category === f.category) &&
      (f.file === 'all' || x.filePath === f.file) &&
      (f.status === 'all' || (f.status === 'active' ? x.status !== 'dismissed' : x.status === f.status)),
  );
}
